import React from 'react';
import './LoadingOverlay.css';  // Zaimportuj styl CSS

const LoadingOverlay = ({ isLoading, message }) => {
  if (!isLoading) return null;

  return (
    <div className="overlay">
      <div className="loading-box">
        <div className="loading-animation">
          <div className="spinner"></div>
        </div>
        <p style={{'color':'black'}}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
